import { useEffect, useState } from 'react'
import { usersRef } from 'firebase/index'
import { UserType } from 'types/user'

const useQueryOrderedUsers = (userIds: string[]): UserType[] => {
  const [users, setUsers] = useState<UserType[]>([])
  // 受取番号に対応するユーザー情報を取得する
  useEffect(() => {
    if (userIds.length === 0) return
    const promises = []
    for (let i = 0; i < userIds.length; i = (i + 1) | 0) {
      const id = userIds[i]
      promises.push(
        usersRef
          .doc(id)
          .get()
          .then((snapshot) => {
            const data = snapshot.data() as UserType
            data.user_id = snapshot.id
            return data
          })
      )
    }
    Promise.all(promises)
      .then((users) => setUsers([...users]))
      .catch((error) => console.error(error))
  }, [userIds])
  return users
}

export default useQueryOrderedUsers
